import { render } from "./CtaSection.vue?vue&type=template&id=1979c15f"
import script from "./CtaSection.vue?vue&type=script&lang=js"
export * from "./CtaSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__